import React from 'react'

import SmartCategory from '.'
import DotLoader from '../../components/Loader/DotLoader'
import { useSelectedGames } from '../GamesBlock/hooks/useSelectedGames'
import { filters, getGamesForSmartCategory } from './utils'

export default function SmartCategoryWithData() {
  const { selectedGames, isPending } = useSelectedGames({ filters })

  if (isPending) {
    return <DotLoader />
  }

  const gamesSlugs = getGamesForSmartCategory(selectedGames)

  if (gamesSlugs.length === 0) {
    return null
  }

  return <SmartCategory gamesSlugs={gamesSlugs} />
}
